module.exports = __webpack_public_path__ + "static/media/percentage.a0441735.svg";